import { render, staticRenderFns } from "./my-live-order.vue?vue&type=template&id=286ddb96&scoped=true"
import script from "./my-live-order.vue?vue&type=script&lang=js"
export * from "./my-live-order.vue?vue&type=script&lang=js"
import style0 from "./my-live-order.vue?vue&type=style&index=0&id=286ddb96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ddb96",
  null
  
)

export default component.exports